/**
 * Style Notes room (#855). One voice, one resolved instruction.
 * The book you open is the card you edit.
 */
export function styleCardsPath(storyId) {
  return storyId ? `/style-cards/${storyId}` : '/style-cards';
}

/**
 * The book the left map is for. A bare /style-cards address is not
 * a destination — the door stays closed until a book id is known.
 */
export function styleCardsBookId({ pathname = '', currentStory, currentSession } = {}) {
  const onStyle = (pathname || '').match(/^\/style-cards\/([^/]+)/);
  if (onStyle?.[1]) return onStyle[1];

  const notes = (pathname || '').match(/^\/projects\/[^/]+\/stories\/([^/]+)\/notes\/?$/);
  if (notes?.[1]) return notes[1];

  if ((pathname || '').startsWith('/chat/') && currentSession?.story_id) {
    return currentSession.story_id;
  }

  return currentStory?.id || currentSession?.story_id || null;
}

export function styleCardsPathForBook(ctx) {
  const id = styleCardsBookId(ctx);
  return id ? styleCardsPath(id) : null;
}

export function povSourceLabel(source) {
  if (source === 'scene') return 'this scene';
  if (source === 'chapter') return 'chapter override';
  if (source === 'book') return 'book default';
  if (source && source.includes('+')) {
    return source.split('+').map(povSourceLabel).join(' + ');
  }
  return source || 'unset';
}

export const POV_MODES = [
  { value: '', label: 'Not set' },
  { value: 'first_person', label: 'First person' },
  { value: 'close_third', label: 'Close third' },
  { value: 'limited_third', label: 'Limited third' },
  { value: 'omniscient', label: 'Omniscient' },
  { value: 'second_person', label: 'Second person' },
];
